import { useRunRj } from 'react-rocketjump';
import { u as useQsDataTableFactory, a as useReactDataTableFactory } from './useReactDatatableFactory-4a252af5.js';
import 'react';
import 'magik-react-hooks/useRouterQueryParams';
import 'magik-react-hooks/qpUtils';
import 'magik-react-hooks/useConstant';
import 'lodash.get';

var useQsDataTable = useQsDataTableFactory(useRunRj);
var useReactDataTable = useReactDataTableFactory(useRunRj);

export { useQsDataTable, useReactDataTable };
